import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './routes/routes';
import "primereact/resources/themes/lara-light-cyan/theme.css"
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './App.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Suspense fallback={<>Loading...</>}>
    <AppRoutes />
  </Suspense >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
